import React from 'react';

export const AirtableSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18.3959 7.81668L7.21116 12.4448C6.58917 12.7022 6.59561 13.5857 7.2215 13.8338L18.4531 18.2877C19.44 18.6791 20.539 18.6791 21.5257 18.2877L32.7575 13.8338C33.3832 13.5857 33.3898 12.7022 32.7677 12.4448L21.583 7.81668C20.5626 7.39444 19.4163 7.39444 18.3959 7.81668Z"
			fill="#FFBF00"
		/>
		<path
			d="M20.9858 20.7199V31.8465C20.9858 32.3758 21.5195 32.7381 22.0114 32.5431L34.5268 27.6852C34.8126 27.572 34.9999 27.2959 34.9999 26.9886V15.862C34.9999 15.3328 34.4663 14.9704 33.9744 15.1654L21.4589 20.0233C21.1734 20.1366 20.9858 20.4126 20.9858 20.7199Z"
			fill="#26B5F8"
		/>
		<path
			d="M18.0635 21.2941L14.3492 23.0875L13.972 23.2698L6.13138 27.0266C5.63437 27.2664 5 26.9042 5 26.3521V15.9088C5 15.7091 5.10242 15.5366 5.23977 15.4067C5.29709 15.3492 5.36204 15.3019 5.42953 15.2644C5.6169 15.152 5.88415 15.122 6.11137 15.2119L18.0011 19.9228C18.6054 20.1625 18.6529 21.0094 18.0635 21.2941Z"
			fill="#ED3049"
		/>
		<path
			d="M18.0635 21.2941L14.3492 23.0875L5.23981 15.4067C5.29712 15.3492 5.36207 15.3019 5.42956 15.2644C5.61693 15.152 5.88418 15.122 6.11141 15.2119L18.0011 19.9228C18.6055 20.1625 18.6529 21.0094 18.0635 21.2941Z"
			fill="black"
			fillOpacity="0.25"
		/>
	</svg>
);
